import React from 'react';
import { useHistory } from "react-router-dom";


const UserGiftlistRow = (props) => {

    const history = useHistory();

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return <img src={"https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2"} alt="" />;
	    }
	    // if(userData.FBID && userData.FBID !== "0") {
	    //     return <img src={"https://graph.facebook.com/" + userData.FBID + "/picture?type=large"} alt="" />;
        // }
        return (<span>{userData.FirstName ? userData.FirstName.charAt(0) : '?'}{userData.LastName ? userData.LastName.charAt(0) : ''}</span>);
    }

    const goToGiftlist = () => {
        if(props.me) {
            history.push("/my-giftlist");
        } else {
            history.push("/gift-list/" + props.giftlist.urlCode);
        }
        props.close();
    }

    return (
    <div onClick={() => goToGiftlist()} className="kt-portlet kt-widget kt-widget--general-3 giftlist-row m-0">
        <div className="kt-portlet__body kt-portlet__body--fit">
            <div className="kt-widget__top pt-2 pb-2 pl-2 pr-2">
                <div className="kt-media kt-media--md kt-media--circle kt-media--info">
                    {buildAvatarUrl(props.giftlist)}
                </div>
                <div className="kt-widget__wrapper">
                    <div className="kt-widget__label">
                        <span className="kt-widget__title">
                            {props.giftlist.FirstName} {props.giftlist.LastName}
                        </span>
                        { props.giftlist.addedBy 
                            && props.giftlist.addedBy !== "0"
                            && props.giftlist.isUser !== "1" ? <div>
                        <span className="kt-widget__desc">
                            Owner: {props.giftlist.addedBy.FirstName} {props.giftlist.addedBy.LastName}
                        </span></div> : <></> }
                    
                        
                    </div>
                    
                    
                    <div className="kt-widget__stats">
                        <div className="kt-widget__stat" href="#">
                            <span className="kt-widget__value">{(props.totalItems || props.totalItems === 0) ? props.totalItems : props.giftlist.totalItems}</span>
                            <span className="kt-widget__caption">Items</span>
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>);
}

export default UserGiftlistRow;
